module.exports = __webpack_public_path__ + "static/thpcdinosaurmain-bb9ba49e3a6445e449483087cb6f75f3.jpeg";